import React from 'react'
import { Button } from '../Button'
import "./herosection.css";

function HeroSection () {
    return(

            <div className="hero-container">
                <video src="/videos/video-1.mp4" autoPlay loop muted/>
                <h1>ADVANTURE AWITS</h1>
                <p>what are you wating for ?</p>
                <div className="hero-btns">
                    <Button className="btn" buttonStyle="btn--outline" buttonSize="btn--large" >
                        GET STARTED
                    </Button>
                    <Button className="btn" buttonStyle="btn--primary" buttonSize="btn--large">
                        WATCH TRAILER <i className="far fa-play-circle"/>
                    </Button>
                </div>
            </div>
            
    )
}

export default HeroSection;